/**
 * Created with Intellij IDEA
 * @User : Abdellatif
 * @Date : 11/26/2020
 * @Time : 5:46 PM
 *
 **/

export default {
  LOAD_ALL_TAGS_REQUEST: 'LOAD_ALL_TAGS_REQUEST',
  LOAD_ALL_TAGS: 'LOAD_ALL_TAGS',
  LOAD_TAG_REQUEST: 'LOAD_TAG_REQUEST',
  LOAD_TAG: 'LOAD_TAG',
  ADD_TAG: 'ADD_TAG',
  UPDATE_TAG: 'UPDATE_TAG',
  DELETE_TAG: 'DELETE_TAG',

  LOAD_ALL_STATE_TAGS_REQUEST:'LOAD_ALL_STATE_TAGS_REQUEST',
  LOAD_ALL_STATE_TAGS:'LOAD_ALL_STATE_TAGS',
  LOAD_STATE_TAG_REQUEST: 'LOAD_STATE_TAG_REQUEST',
  LOAD_STATE_TAG: 'LOAD_STATE_TAG',
  ADD_STATE_TAG: 'ADD_STATE_TAG',
  UPDATE_STATE_TAG: 'UPDATE_STATE_TAG',
  UPDATE_STATES:'UPDATE_STATES',
  DELETE_STATES: 'DELETE_STATES',
  DELETE_STATE_TAG:'DELETE_STATE_TAG'
}